import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authService } from './authService';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../features/auth/authSlice';
import { toast } from 'react-toastify';

const Callback: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const handleCallback = async () => {
            try {
                const params = new URLSearchParams(location.search);
                const code = params.get('code');
                const error = params.get('error');

                if (error) {
                    throw new Error(`Authorization error: ${error}`);
                }

                if (!code) {
                    throw new Error('No authorization code received');
                }

                // Get the code verifier from sessionStorage
                const codeVerifier = sessionStorage.getItem('pkce_code_verifier');
                if (!codeVerifier) {
                    throw new Error('No PKCE verifier found');
                }

                // Exchange code for tokens
                const tokens = await authService.exchangeCodeForTokens(code, codeVerifier);
                authService.saveTokens(tokens);

                // ✅ Create user object matching your User type
                const user = {
                    name: 'User', // You can parse this from ID token if available
                    email: 'user@example.com', // You can parse this from ID token if available
                    token: tokens.access_token,
                };

                // Save user to Redux and localStorage
                dispatch(loginSuccess(user));

                // Clean up
                sessionStorage.removeItem('pkce_code_verifier');
                sessionStorage.removeItem('tenant');

                // Redirect to dashboard
                navigate('/dashboard', { replace: true });
            } catch (error) {
                // console.error('Callback error:', error);
                toast.error('Authentication failed. Please try again.');
                navigate('/login', { replace: true });
            }
        };

        handleCallback();
    }, [location, navigate, dispatch]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
                <h2 className="mt-4 text-xl font-semibold text-gray-700">Authenticating...</h2>
                <p className="mt-2 text-gray-500">Please wait while we complete your sign in</p>
            </div>
        </div>
    );
};

export default Callback;